import { render, staticRenderFns } from "./EventsImportFields.vue?vue&type=template&id=1d67941a&scoped=true&"
import script from "./EventsImportFields.vue?vue&type=script&lang=js&"
export * from "./EventsImportFields.vue?vue&type=script&lang=js&"
import style0 from "./EventsImportFields.vue?vue&type=style&index=0&id=1d67941a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d67941a",
  null
  
)

export default component.exports